<template>
  <div v-if="loaded" class="container body-container">
    <div v-if="error">
      You are not authorized to execute Slash Commands from Slack into EndCustomer!
    </div>
    <div v-else>
      Your Slack account has been mapped to your EndCustomer account. You can now resubmit your
      initial request from within Slack!
    </div>
  </div>
</template>

<script>
import Axios from '@/packages/axios/Axios';

export default {
  data() {
    return {
      error: false,
      loaded: false,
    };
  },
  mounted() {
    Axios.get(`/v1/slack/${this.$route.params.nonce}`)
      .then(() => {
        this.error = false;
      })
      .catch(() => {
        this.error = true;
      })
      .finally(() => {
        this.loaded = true;
      });
  },
  name: 'SlackAuthz',
};
</script>

<style scoped></style>
